module.exports = __webpack_public_path__ + "static/media/Shipping.ac6963e9.svg";